import React from 'react';

const CONFETTI_COLORS = ['#ff8a00', '#ff6a00', '#ffb347', '#4CAF50', '#FFBCA7', '#ffd700'];

function ConfettiBurst() {
    const pieces = Array.from({ length: 24 }, (_, i) => ({
        id: i,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        left: `${5 + (i * 4) % 90}%`,
        delay: `${(i % 8) * 0.05}s`,
        rotate: `${(i * 37) % 360}deg`,
    }));

    return (
        <div className="launch-confetti" aria-hidden="true">
            {pieces.map((p) => (
                <span
                    key={p.id}
                    className="launch-confetti-piece"
                    style={{
                        left: p.left,
                        backgroundColor: p.color,
                        animationDelay: p.delay,
                        transform: `rotate(${p.rotate})`,
                    }}
                />
            ))}
        </div>
    );
}

export default function LaunchMilestone({ message, onDone }) {
    React.useEffect(() => {
        const id = window.setTimeout(() => {
            if (onDone) onDone();
        }, 1200);
        return () => window.clearTimeout(id);
    }, [onDone]);

    return (
        <div className="launch-milestone" role="status" aria-live="polite">
            <ConfettiBurst />
            <div className="launch-milestone-icon" aria-hidden="true">✓</div>
            <p className="launch-milestone-text">{message}</p>
        </div>
    );
}
